import script from "./PrescriptionProcess_bak_20260403_2.vue?vue&type=script&setup=true&lang=js"
export * from "./PrescriptionProcess_bak_20260403_2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__